<template>
  <v-container fluid fill-height pt-15 class="test_purple">
    <v-row class="test_red fill-height" justify="center">
      <v-col cols="11" md="10" lg="8">
        <v-row class="test_green mt-10">
          <v-col cols="12">
            <span
              class="section-title"
              v-text="$t('customerProfile.profile')"
            />
          </v-col>
          <v-tabs
            v-model="tab"
            background-color="transparent"
            color="primary"
            :vertical="$vuetify.breakpoint.xsOnly"
          >
            <v-tab
              v-for="(item, index) in items"
              :key="index"
              class="tab-container-text"
            >
              <span class="tab-title" v-text="$t('customerProfile.' + item)" />
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" class="test_pink tab-content">
            <v-tab-item :value="0">
              <PersonalInfo />
            </v-tab-item>
            <v-tab-item :value="1">
              <PaymentMethod />
            </v-tab-item>
            <v-tab-item :value="2">
              <AddressBook />
            </v-tab-item>
            <v-tab-item :value="3">
              <OrderHistory />
            </v-tab-item>
            <v-tab-item
              v-if="
                this.$store.getters.appInfo?.promoReward &&
                this.$store.getters.appInfo?.promoReward > 0
              "
              :value="4"
            >
              <ShareComponent />
            </v-tab-item>
            <v-tab-item
              v-if="
                this.$store.getters.appInfo?.promoReward === null ||
                this.$store.getters.appInfo?.promoReward === '0.00'
              "
              :value="4"
            >
              <CreditComponent />
            </v-tab-item>
            <v-tab-item
              v-if="
                this.$store.getters.appInfo?.promoReward === null ||
                this.$store.getters.appInfo?.promoReward === '0.00'
              "
              :value="5"
            >
              <SettingsComponent />
            </v-tab-item>
            <v-tab-item
              v-if="
                this.$store.getters.appInfo?.promoReward &&
                this.$store.getters.appInfo?.promoReward > 0
              "
              :value="5"
            >
              <CreditComponent />
            </v-tab-item>
            <v-tab-item
              v-if="
                this.$store.getters.appInfo?.promoReward &&
                this.$store.getters.appInfo?.promoReward > 0
              "
              :value="6"
            >
              <SettingsComponent />
            </v-tab-item>
          </v-tabs-items>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  PersonalInfo,
  PaymentMethod,
  AddressBook,
  OrderHistory,
  SettingsComponent,
  ShareComponent,
  CreditComponent,
} from "./components";
export default {
  layout: "Customer",
  name: "Profile",
  middleware: "customer",
  components: {
    PersonalInfo,
    PaymentMethod,
    AddressBook,
    OrderHistory,
    SettingsComponent,
    ShareComponent,
    CreditComponent,
  },
  data: () => ({
    tab: null,
    items: [
      "personalInfo",
      "paymentMethods",
      "addresses",
      "orderHistory",
      "share",
      "credits",
      "settings",
    ],
  }),
  beforeMount() {
    if (
      this.$store.getters.appInfo?.promoReward &&
      this.$store.getters.appInfo?.promoReward > 0
    ) {
      this.items = [
        "personalInfo",
        "paymentMethods",
        "addresses",
        "orderHistory",
        "share",
        "credits",
        "settings",
      ];
    } else {
      this.items = [
        "personalInfo",
        "paymentMethods",
        "addresses",
        "orderHistory",
        "credits",
        "settings",
      ];
    }
  },
};
</script>
<style lang="scss" scoped>
.tab-content {
  width: 100%;
}
.tab-container-text {
  justify-content: center;
}
.section-title {
  font-size: 4rem;
  font-family: $font_Bold;
}
.tab-title {
  font-size: 1.2rem !important;
}

@media only screen and (min-width: 320px) and (max-width: 479px) {
  .section-title {
    font-size: 3rem;
  }
  .tab-container-text {
    justify-content: start;
  }
  .tab-title {
    font-size: 1rem !important;
    text-align: left;
  }
}

@media only screen and (min-width: 480px) and (max-width: 767px) {
}
</style>
